import React, { useState } from 'react';
import ClientManager from './ClientManager';
import CompanyManager from './CompanyManager';
import './CadastroPanel.css';

const CadastroPanel = () => {
  const [active, setActive] = useState('clientes');

  return (
    <div className="cadastro-panel">
      <div className="cadastro-tabs">
        <button className={active === 'clientes' ? 'active' : ''} onClick={() => setActive('clientes')}>Clientes</button>
        <button className={active === 'empresas' ? 'active' : ''} onClick={() => setActive('empresas')}>Empresas</button>
      </div>
      <div className="cadastro-content">
        {active === 'clientes' && <ClientManager />}
        {active === 'empresas' && <CompanyManager />}
      </div>
    </div>
  );
};

export default CadastroPanel;
